import { useEffect } from "react";

import { useSelector } from "react-redux";

import { NoData } from "app/pages/industry-analysis/frame/NoData";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";
import type { ISegmentsModule } from "app/services/segments/segmentsApiService";
import { allTrackers } from "app/services/track/track";

import { usePrimaryCategoryObject } from "../common/hooks/usePrimaryCategoryObject";

export const WithHasAccessToSegment = (Component) => {
    return function WrappedComponent(props) {
        const categoryObject = usePrimaryCategoryObject();
        const segmentsModule: ISegmentsModule = useSelector((state) => {
            const { segmentsModule } = state;
            return segmentsModule;
        });
        const hasUnauthorizedSegment = CategoryServiceUtils.hasUnauthorizedSegment(categoryObject, segmentsModule);

        useEffect(() => {
            if (!hasUnauthorizedSegment) {
                return;
            }
            const { categoryId, name } = categoryObject;
            allTrackers.trackEvent(
                "N/A state",
                "Analyze custom industry",
                `contains unauthorized segment/${name}/${categoryId}`,
            );
        }, [categoryObject, hasUnauthorizedSegment]);

        if (hasUnauthorizedSegment) {
            return (
                <NoData
                    noDataTitleKey={"industry.research.unauthorized.segment.title"}
                    noDataSubTitleKey={"industry.research.unauthorized.segment.subtitle"}
                />
            );
        }
        return <Component {...props} />;
    };
};
